<template>
  <v-sheet class="multiCam">
    <div class="multiCam_title">
      <span class="multiCam_title_text">マルチカメラ</span>
    </div>
    <div class="multiCam_controller">
      <row-select
        :group="[
          {
            defaultItem: numberOfColumns - 1,
            list: camsSelectList,
            label: '1列表示',
            textOnSelect: handleSelectColumn,
          },
          /*{
            defaultItem: 0,
            list: [{ text: 'ローテーション' }],
            label: 'ローテーション',
          },*/
        ]"
        @select="handleSelectController"
      />
    </div>
    <section v-if="!enterPageLoading" class="multiCam_videos-wrapper">
      <div class="multiCam_videos">
        <v-container v-if="iamKey && iamSecret" :class="columnNumberClasses">
          <v-row>
            <template v-for="(cam, i) in cameraQueue">
              <v-col
                :key="i"
                class="multiCam_videos-col"
                :style="{ 'max-width': `${100 / numberOfColumns}%` }"
              >
                <skeleton-video
                  v-if="!cam.accessKeyId"
                  :show-controllers="false"
                  style="aspect-ratio: 16 / 9"
                />
                <VideoStream
                  v-else
                  :id="cam.id"
                  ref="videoStream"
                  :key="i"
                  :meta="cam"
                  :show-about="showCameraAbout"
                  :show-auto-focus="showAutoFocus"
                  :volume-on-right="rightController(i)"
                  :controller-on-right="rightController(i)"
                  is-attach
                  class="multiCam_videos-stream"
                  :size="100 / numberOfColumns <= 50 ? 'small' : 'large'"
                  :stream-config="{
                    accessKeyId: iamKey,
                    secretAccessKey: iamSecret,
                    streamName: cam.kvsVideoStreamName,
                    region: cam.awsRegionName,
                    autoplay: true,
                    refreshOnSessionChange: true,
                    connectOnPresence: true,
                  }"
                  :title="cam.name"
                  :set-time="setTime[i]"
                  main
                  :event="[event]"
                  :live="live[i]"
                  :playing="playing[i]"
                  :playback-rate.sync="playbackRate"
                  :disable-zoom="!fullscreen"
                  zoomout-on-restore
                  show-skeleton
                  controller-size="small"
                  :show-controllers="showVideoController"
                  :hide-display-controller="!fullscreen"
                  @onFullscreenChange="handleFullscreenChange"
                  @timeupdate="handleTimestamp($event, i)"
                  @onRefresh="handleRefresh(i)"
                  @update:live="handleUpdateLive($event, i)"
                  @update:playing="handleUpdatePlaying($event, i)"
                  @onSpeakerOn="handleSpeaker($event, i)"
                  @onAction="handleVideoStreamEvent"
                >
                  <template
                    slot-scope="{
                      changeCurrentTime,
                      displayLive,
                      playerStatus,
                      isInGap,
                    }"
                  >
                    <VideoSeek
                      ref="seek"
                      :name="'cam' + i"
                      :v-show="false"
                      class="videoStream_videoseek"
                      :player-status="playerStatus"
                      fullscreen-mode
                      :live="live[i]"
                      :playing="playing[i]"
                      :playback-rate.sync="playbackRate"
                      :timestamp="timestamp[i]"
                      :show-playback-rate="isInGap"
                      :can-edit-date-time="canEditVideoSeekDateTime"
                      @update:live="handleUpdateLive($event, i)"
                      @update:playing="handleUpdatePlaying($event, i)"
                      @setTime="(val) => getTime(val, i)"
                      @onLive="displayLive"
                      @changeCurrentTime="changeCurrentTime"
                    />
                  </template>
                </VideoStream>
              </v-col>
              <v-responsive
                v-if="(i + 1) % numberOfColumns === 0"
                :key="`width-${i}`"
                width="100%"
              />
            </template>
          </v-row>
        </v-container>
        <infinite-loading
          ref="infiniteScroll"
          spinner="spiral"
          force-use-infinite-wrapper=".multiCam_videos-wrapper"
          @infinite="handleInfiniteScroll($refs)"
        >
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>
    </section>
  </v-sheet>
</template>

<script>
import dayjs from 'dayjs';
import { mapActions, mapGetters, mapState } from 'vuex';
import VideoService from '@/services/video.service';
import VideoStream from '@/components/VideoStream.vue';
import RowSelect from '../../components/inputs/RowSelect.vue';
import VideoSeek from '@/components/VideoSeek.vue';
import CameraService from '@/services/CameraService';
import InfiniteLoading from 'vue-infinite-loading';
import { paginate } from '@/utils/helpers';
import EventBus from '@/utils/eventBus';
import { EventBusEvents, KVSErrorCodes, PlayerStatus } from '@/globals/enums';
const customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);

export default {
  name: 'MultiCam',
  components: {
    VideoSeek,
    VideoStream,
    RowSelect,
    InfiniteLoading,
  },
  data() {
    return {
      videoService: new VideoService(),
      camsSelectList: [...Array(6).keys()].map((key) => ({
        text: `${key + 1}列表示`,
      })),
      attachingCredentials: false,
      loading: false,
      live: [],
      playing: [],
      playbackRate: 1,
      eventLoading: false,
      events: [],
      setTime: [],
      timestamp: [],
      fullscreen: false,
      hasDataCameras: false,
      numberOfColumns: 1,
      movingIndex: 0,
      futureIndex: 0,
      movedTo: '',
      movedFrom: '',
      isDroppingOnMain: false,
      showVideoController: true,
      infiniteScrollState: null,
      dataMounted: false,
      page: 0,
      cameraQueue: [],
      cameraListInPages: {},
    };
  },
  computed: {
    ...mapGetters('common', {
      currentGroupCamList: 'currentGroupCamList',
    }),
    ...mapState({
      iamKey: (state) => state.common.iam.accessKeyId,
      iamSecret: (state) => state.common.iam.secretAccessKey,
      currentCameraPolicy: (state) => state.common.currentCameraPolicy,
      currentHomeGroup: (state) => state.common.currentHomeGroup,
      homeCameraGroups: (state) => state.common.homeCameraGroups,
      cameraList: (state) => state.common.cameraList,
      isCurrentAvatarOwner: (state) => state.settings.isCurrentAvatarOwner,
      event: (state) => state.event.event,
      enterPageLoading: (state) => state.multiCam.enterPageLoading,
    }),
    canEditVideoSeekDateTime() {
      return this.isCurrentAvatarOwner || !this.currentCameraPolicy.liveOnly;
    },
    showAutoFocus() {
      return !this.currentCameraPolicy.liveOnly || this.isCurrentAvatarOwner;
    },
    showCameraAbout() {
      return (
        (!this.currentCameraPolicy.access &&
          !this.currentCameraPolicy.liveOnly) ||
        this.isCurrentAvatarOwner
      );
    },
    routeId() {
      return this.$route.params.id;
    },
    columnNumberClasses() {
      return 'multiCam_container multiCam_container--' + this.numberOfColumns;
    },
  },
  watch: {
    event: {
      handler: function () {
        this.setEvent();
      },
      immediate: true,
    },
    live(val) {
      if (val) {
        // this.$router.push({ name: 'home' })
      }
    },
    currentGroupCamList: {
      handler: function (val) {
        this.cameraListInPages = paginate(this.currentGroupCamList, 8);
        if (val.length) {
          val.forEach(() => {
            this.timestamp.push(dayjs().valueOf());
            this.setTime.push(null);
            this.playing.push(false);
          });
        }
      },
      immediate: true,
    },
  },
  created() {
    this.numberOfColumns = CameraService.getMulticamLayout() || 1;
  },
  mounted() {
    this.dataMounted = false;
    this.setEvent();

    EventBus.on(EventBusEvents.CamGroupChanged, this.handleHomeGroupChanged);
  },
  beforeDestroy() {
    // ensure loading states are cleared when component is destroyed
    this.setIsLoading(false);
    EventBus.off(EventBusEvents.CamGroupChanged, this.handleHomeGroupChanged);
  },
  methods: {
    ...mapActions('common', ['setIsLoading']),
    changeAllCamLiveStatus(status) {
      // change all cameras to live if cameras already mapped in live as an array, if not, map all cameras to live
      if (this.live.length) {
        this.live.forEach((_, index) => {
          this.$set(this.live, index, status);
        });
      } else {
        this.currentGroupCamList.forEach(() => {
          this.live.push(status);
        });
      }
    },
    handleHomeGroupChanged() {
      this.page = 0;
      this.changeAllCamLiveStatus(true);
      this.cameraQueue = [];
      this.$refs.infiniteScroll?.stateChanger?.reset();
    },
    handleVideoStreamEvent(e) {
      if (e.type === 'error') {
        const { error, code } = e.payload;
        if (error) {
          switch (code) {
            case KVSErrorCodes.GET_DATA_ENDPOINT_TOKEN_EXP:
              this.handleKVSExpiration({ error, code });
              break;
            case PlayerStatus.StreamingSessionExpired:
              this.handleStreamingSessionExpiration({ error, code });
              break;
            default:
              break;
          }
        }
      }
    },
    async handleKVSExpiration() {
      if (this.attachingCredentials) {
        return;
      }

      this.attachingCredentials = true;
      const requests$ = [];
      for (const page of [...Array(this.page)].keys()) {
        requests$.push(
          this.videoService.attachCameraIamAccessKey(
            this.cameraListInPages[page]
          )
        );
      }
      await Promise.all(requests$);
      this.attachingCredentials = false;
    },
    async handleStreamingSessionExpiration() {
      if (this.attachingCredentials) {
        return;
      }

      this.attachingCredentials = true;
      const requests$ = [];
      for (const page of [...Array(this.page)].keys()) {
        requests$.push(
          this.videoService.attachCameraIamAccessKey(
            this.cameraListInPages[page]
          )
        );
      }
      await Promise.all(requests$);
      this.attachingCredentials = false;
    },
    handleSpeaker(status, i) {
      if (status) {
        this.currentGroupCamList.forEach((element, index) => {
          if (i === index) {
            this.$refs.videoStream[index].setVolume(5);
          } else {
            this.$refs.videoStream[index].setVolume(0);
          }
        });
      }
    },
    handleSelectDisplay(e) {
      return e.text;
    },
    handleSelectColumn(e) {
      return e.text;
    },
    handleUpdatePlaying(event, index) {
      this.$set(this.playing, index, event);
    },
    handleUpdateLive(event, index) {
      this.$set(this.live, index, event);
    },
    handleTimestamp(timestamp, index) {
      this.$set(this.timestamp, index, timestamp);
    },
    handleRefresh(index) {
      this.changeAllCamLiveStatus(true);
      this.$refs.seek[index].refresh(dayjs().valueOf());
    },
    handleSelectController(selectedItem) {
      if (selectedItem.group === 0) {
        this.numberOfColumns = selectedItem.index + 1;
        CameraService.setMulticamLayout(this.numberOfColumns);
      }
      const hasMore = this.cameraListInPages.length >= this.page;
      if (this.$refs.infiniteScroll?.stateChanger && hasMore) {
        this.$refs.infiniteScroll.stateChanger.reset();
      }
    },
    // handle main camera status e.g. live, nodata, error
    handleMainCameraStatus({ status }) {
      if (status === 'live') {
        this.hasDataCameras = true;
      }
    },
    // handle fullscreen change e.g. true, false
    handleFullscreenChange({ fullscreen }) {
      this.fullscreen = fullscreen;
    },
    setEvent() {
      if (this.routeId && this.event.eventStartDate) {
        this.changeAllCamLiveStatus(false);
        const eventStartDate = dayjs(
          this.event.eventStartDate,
          'YYYYMMDDHHmmss'
        ).subtract(1, 'seconds');
        this.getTime(eventStartDate);
      }
    },
    getTime(val, index) {
      this.$set(this.setTime, index, val);
    },
    rightController(index) {
      return this.numberOfColumns > 1 && index % this.numberOfColumns === 0;
    },
    async handleInfiniteScroll($refs) {
      if (!this.$refs.infiniteScroll?.stateChanger) {
        console.warn('[WARN] $refs.infiniteScroll is undefined');
        return;
      }
      this.infiniteScrollState = $refs;
      if (
        this.cameraListInPages[this.page] &&
        this.cameraListInPages[this.page].length
      ) {
        try {
          await this.videoService.attachCameraIamAccessKey(
            this.cameraListInPages[this.page]
          );
        } catch (error) {
          console.error('[ERROR] Failed to attach IAM access key:', error);
        }
      } else {
        this.$refs.infiniteScroll.stateChanger.complete();
        return;
      }

      this.cameraListInPages[this.page].forEach((cam) => {
        this.cameraQueue.push(cam);
      });

      this.page += 1;
      const hasMore = this.cameraListInPages.length > this.page;
      if (this.$refs.infiniteScroll?.stateChanger) {
        if (hasMore) {
          this.$refs.infiniteScroll.stateChanger.loaded();
        } else {
          this.$refs.infiniteScroll.stateChanger.complete();
        }
      }
    },
  },
};
</script>

<style lang="scss">
.multiCam {
  max-height: 100vh;
  &.v-sheet {
    padding: 0;
  }
  &_container {
    padding: 0;
    &--1 {
      min-width: 380px;
    }
    &--2 {
      min-width: 570px;
    }
    &--3 {
      min-width: 580px;
    }
    &--4 {
      min-width: 810px;
    }
    &--5,
    &--6 {
      min-width: 900px;
    }
  }
  &_controller {
    display: flex;
    margin-bottom: 9px;
    padding: 0 30px;
  }
  &_no-data-cameras {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    background-color: #8c8c8a85;
  }
  display: flex;
  flex-direction: column;
  &_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2px;
    color: var(--text-color);
    padding: 30px 30px 0;
    max-width: 966px;
    @media (min-width: 1280px) {
      width: calc(68vw - 339.77px);
    }
    &_text {
      font-size: 14px;
      font-weight: bold;
      line-height: 1.14;
    }
    &_type {
      color: var(--warning-color-lighten1);
      font-size: 12px;
      font-weight: 600;
    }
  }
  &_videos {
    position: relative;
    padding: 0 30px 30px;
    &-wrapper {
      height: 100%;
      @include scrollBar;
      overflow-x: hidden;
    }
    &-stream {
      video {
        vertical-align: bottom;
      }
    }
  }
}
</style>
